tendersList.directive('setFocus', function() {
   return {
       restrict: 'A',
       link: function(scope, el) {
           el[0].focus();
       }
   };
});